import videoPlayer from '@motionelements/core/src/store/modules/videoPlayer.js';

export default {
  namespaced: true,
  state: () => videoPlayer.state,
  getters: videoPlayer.getters,
  actions: videoPlayer.actions,
  mutations: videoPlayer.mutations,
};
